import React from "react";
import branchOffMessage from "images/helpBranchOffMessage.png";

const HlpInputEntry = () => {
  return (
    <>
      <h1>Type Your Messages Here</h1>
      And carry on your conversations in threads.
      <img alt="branch off message" src={branchOffMessage} />
    </>
  );
};

export default HlpInputEntry;
